module.exports = __webpack_public_path__ + "img/defaulturun-kucuk.6eff972d.jpg";